<template>
	<div class="index" v-loading.fullscreen.lock='$store.state.loading' @click="closeMine()">
		<hed v-if="routeName!='appAgreement'"></hed>
		<man></man>
		<foo v-if="routeName!='communication'&&routeName!='appAgreement'"></foo>
		<login v-if="isLoginDialogOpen"></login>
	</div>
</template>

<script>
	import hed from "./hed.vue"
	import man from "./man.vue"
	import foo from "./foo.vue"
	import login from '@/components/login.vue'
	import { mapState } from 'vuex';
	export default {
		name:'index',
		components:{ hed,man,foo,login },
		data() {
			return {
				routeName:''
			}
		},
		computed: {
		    ...mapState(['isLoginDialogOpen','standing']),
		},
		created() {
			this.routeName = this.$route.name
			this.appInit()
		},
		watch: {
			$route(e) {
				this.routeName = e.name
			}
		},
		methods: {
			closeMine(){
				
			},
			appInit(){
				if(this.$util.validLogin('rest')){
					if(!this.$store.state.sdk_ready){
						let userID,userSig;
						this.$axios.get('/api/client/User/info').then(res=>{
							if(res.code==200){
								if(res.data.type=='1'){
									userID = res.data.en_im_account
									userSig = this.$util.getStorage('en_im_sign')
								}else{
									userID = res.data.user_im_account
									userSig = this.$util.getStorage('user_im_sign')
								}
								console.log(userID,userSig)
								this.tim.login({userID:userID,userSig:userSig}).then((res) => {
									console.log('腾讯IM登录成功------',res)
								}).catch((err) => {
									console.error('腾讯云即时通讯登录失败------',err)
								})
							}else{
								this.$eltips(res.msg,'error')
							}
						})
					}
				}
			}
		}
	}
</script>

<style lang="scss">

</style>